export enum REQUEST {
  NONE,
  PENDING,
  SUCCESS,
  ERROR,
}
